import {
  Button,
  Select,
  Typography,
  MenuItem,
  ListItemButton,
  ListItemText,
  List,
  ListItem,
  Box,
  FormControl,
  InputLabel,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./dayWiseList.scss";
import BarChartIcon from "@mui/icons-material/BarChart";
import AddIcon from "@mui/icons-material/Add";

function DayWiseList({
  newChatClick,
  clickListItem,
  data,
  handleChange,
  error,
  historyData,
  visualizationDetails,
  success,
  tableName,
}) {
  const [projectName, setProjectName] = useState("");

  useEffect(() => {
    if (visualizationDetails?.table_name) {
      let id = data.filter(
        (list) => list.table_name === visualizationDetails?.table_name
      );
      setProjectName(id[0]?.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visualizationDetails]);

  useEffect(() => {
    success && setProjectName("");
  }, [success]);

  if (!historyData) {
    return null;
  }

  const onClickNewChatClick = () => {
    newChatClick();
    setProjectName("");
  };

  return (
    <>
      <div className="chat-button-container">
        <FormControl fullWidth>
          {projectName === "" && (
            <InputLabel
              id="demo-simple-select-label"
              className="color-white"
              shrink={false}
              disabled={projectName !== "" && true}
            >
              Select Unit Operation
            </InputLabel>
          )}
          <Select
            className="project-dropdown"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={projectName}
            onChange={(event) => {
              handleChange(event.target.value);
              setProjectName(event.target.value);
            }}
            error={error}
          >
            {data?.map((project) => (
              <MenuItem key={project.id} value={project.id}>
                {project?.table_name.charAt(0).toUpperCase() +
                  project?.table_name.slice(1)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button
          onClick={() => onClickNewChatClick()}
          className="new-chat-btn"
          size="large"
          variant="outlined"
          startIcon={<AddIcon />}
        >
          New visualization
        </Button>
      </div>
      {Object?.keys(historyData)?.map((keyName) => {
        return (
          <div className="day-list-container">
            <Typography variant="subtitle1" className="days-text-style">
              {keyName}
            </Typography>
            <Box className="day-list-style">
              {historyData[keyName]?.map((item) => {
                return (
                  <List
                    key={item.id}
                    onClick={() => {
                      clickListItem(item.id);
                    }}
                  >
                    <ListItem className="li-list">
                      <ListItemButton>
                        <BarChartIcon className="chat-bubble" />
                        <ListItemText>{item?.label}</ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </List>
                );
              })}
            </Box>
          </div>
        );
      })}
    </>
  );
}

export default DayWiseList;
